// types
import { IHeatPumpCOP } from './types'
// components
import { Suspense, useMemo } from 'react';
import { ICounter } from '../../../automationObjects/Devices/Counter';
import { COPChart } from './';
import { RELATION_TYPE, useGetRelationsOutByIdQuery } from '../../../services/objects';
import { ISensorAnalog } from '../../Devices/SensorAnalog';
import React from 'react';
import { OperatorPanelWrapperFullSize } from '../../components/Layout';
import { useStyletron } from 'styletron-react';


export function OperatorPanel(props: IHeatPumpCOP) {

    const SmallPanel = React.lazy(() =>
        import('./SmallPanel')
            .then(({ SmallPanel }) => ({ default: SmallPanel })),
    );
    const [css,] = useStyletron();
    const { data: objectsOut, isLoading, isSuccess, error, refetch } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: RELATION_TYPE.IsFedBy })

    const { data: objectsIn, isLoading: isLoadingOut, isSuccess: isSuccessOut, error: errorOut, refetch: refetchOut } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: RELATION_TYPE.Feeds })
    const { data: objectTemp, isLoading: isLoadingTemp, isSuccess: isSuccessTemp, error: errorTemp, refetch: refetchTempt } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: RELATION_TYPE.InputOutsideTemperature })

    const itemsOut = useMemo(() => objectsOut?.sort((a: ICounter, b: ICounter) => a.name > b.name ? 1 : -1) ?? [], [objectsOut]);
    const itemsIn = useMemo(() => objectsIn?.sort((a: ICounter, b: ICounter) => a.name > b.name ? 1 : -1) ?? [], [objectsIn]);
    const itemsTemp = useMemo(() => objectTemp?.sort((a: ISensorAnalog, b: ISensorAnalog) => a.name > b.name ? 1 : -1) ?? [], [objectTemp]);
    return (


        <OperatorPanelWrapperFullSize objectId={props.id} resourceGroupId={props.resourceGroupId}
            statusContent={<Suspense fallback={<div>Loading...</div>}>
               <SmallPanel {...props}></SmallPanel>
            </Suspense>}
            additionalContent={
                <div className={css({ minHeight: '300px', height: '600px', width: '100%' })}>
                    <COPChart counterIn={itemsIn} counterOut={itemsOut} temperatur={itemsTemp} ></COPChart>
                </div>}>
        </OperatorPanelWrapperFullSize>

    );
}



